import { selector } from "recoil";
import { floorGroupState } from "./floorGroupState";


export const isShowPointState = selector<boolean>({
    key: "isShowPointState",
    get: ({ get }) => {
        const floorGroup = get(floorGroupState);
        return floorGroup?.is_show_point || false;
    },
});
